import { useState, useEffect } from 'react';
import { useSede } from 'context/SedeContext';
import { getTodayBookingsForCoach, updateAttendance } from '../views/pages/Bookings/service/bookingService';
import { fetchClientById } from '../views/pages/Clients/service/clientsService';
import { handleApiError } from 'utils/ErrorHandler';
import toast from 'react-hot-toast';

export const useMisClases = (userId, userGroups = []) => {
  const { addSedeHeaders, getSedeIdsString } = useSede();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clientModalOpen, setClientModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const headers = addSedeHeaders();
      
      console.log('🔍 Debug useMisClases:', {
        userId,
        userGroups,
        headers,
        sedeIds: getSedeIdsString ? getSedeIdsString() : 'undefined'
      });
      
      const data = await getTodayBookingsForCoach(userId, headers, userGroups);
      
      // Ordenar alumnos con comentarios (condición médica) primero
      const updated = data.map((schedule) => {
        const bookingsWithPriority = [...schedule.bookings].sort((a, b) => {
          const aCond = !!a.client?.notes;
          const bCond = !!b.client?.notes;
          return bCond - aCond;
        });
        return { ...schedule, bookings: bookingsWithPriority };
      });
      
      setSchedules(updated);
    } catch (err) {
      console.error('❌ Error en fetchBookings:', err);
      handleApiError("Error al obtener clases del día");
    } finally {
      setLoading(false);
    }
  };

  const handleAttendanceChange = async (bookingId, status) => {
    try {
      await updateAttendance(bookingId, status);
      toast.success("Asistencia actualizada");
      fetchBookings();
    } catch (error) {
      toast.error("Error al actualizar asistencia");
    }
  };

  const handleViewClient = async (clientId) => {
    try {
      const updatedClient = await fetchClientById(clientId);
      setSelectedClient(updatedClient);
      setClientModalOpen(true);
    } catch (error) {
      console.error("Error al obtener el cliente:", error);
    }
  };

  const toggleClientModal = () => setClientModalOpen(!clientModalOpen);

  useEffect(() => {
    if (userId) {
      fetchBookings();
    }
  }, [userId]);

  return {
    schedules,
    loading,
    clientModalOpen,
    selectedClient,
    handleAttendanceChange,
    handleViewClient,
    toggleClientModal,
    fetchBookings
  };
};
